import React from 'react';

import { FormModal } from 'modules/layer00';
import { ReturnAuthorizationSummarySection } from 'modules/layer01';
import { Button } from '@mui/material';
import * as dataService from './dataService';



export interface IProps {
  returnAuthorizationId: string;
  storeId?: string;

  onClose: () => void;
  onUpdateAcceptanceStatus: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [
    acceptReturn,
    acceptReturnTuple
  ] = dataService.useAcceptReturnAuthorization(props.returnAuthorizationId, props.storeId);



  const handleClickAcceptReturn = React.useCallback(
    async () => {
      if (window.confirm("Are you sure you want to accept this return?")) {
        await acceptReturn('approved');
        props.onUpdateAcceptanceStatus();
      }
    },
    [acceptReturn, props]
  );

  const handleClickDenyReturn = React.useCallback(
    async () => {
      if (window.confirm("Are you sure you want to deny this return?")) {
        await acceptReturn('denied');
        props.onUpdateAcceptanceStatus();
      }
    },
    [acceptReturn, props]
  );



  const loading = acceptReturnTuple.loading;

  return (
    <FormModal.FC
      isDoubleWide
      title="Accept Return"
      onClose={props.onClose}
      isLoading={loading}
      fnGenElCloseButton={() => (
        <Button
          variant="contained"
          size="large"
          color="error"
          disabled={loading}
          onClick={handleClickDenyReturn}>
          Deny
        </Button>
      )}
      fnGenElAcceptButton={() => (
        <Button
          variant="contained"
          size="large"
          color="primary"
          disabled={loading}
          onClick={handleClickAcceptReturn}>
          Accept
        </Button>
      )}>
      <ReturnAuthorizationSummarySection.FC returnAuthorizationId={props.returnAuthorizationId} />
    </FormModal.FC>
  );
};
